import { jsx } from "react/jsx-runtime";
import { useThemeColors } from "@brandclub/bc-widgets";
const USER_BUBBLE_BG = "#f6f8fa";
const VoiceTranscriptBubble = ({ line }) => {
  const { themeColors } = useThemeColors();
  const textColor = themeColors.textPrimary || "#111827";
  if (line.role === "user") {
    return /* @__PURE__ */ jsx(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          marginBottom: 8
        },
        children: /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              maxWidth: "90%",
              background: USER_BUBBLE_BG,
              color: textColor,
              padding: "10px 14px",
              borderRadius: 18,
              fontSize: 14,
              lineHeight: 1.45,
              wordBreak: "break-word",
              whiteSpace: "pre-wrap",
              opacity: line.partial ? 0.85 : 1
            },
            children: line.text
          }
        )
      }
    );
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      style: {
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
        marginBottom: 12
      },
      children: /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            maxWidth: "100%",
            color: textColor,
            fontSize: 14,
            lineHeight: 1.5,
            wordBreak: "break-word",
            whiteSpace: "pre-wrap",
            opacity: line.partial ? 0.85 : 1
          },
          children: line.text
        }
      )
    }
  );
};
export {
  VoiceTranscriptBubble
};
//# sourceMappingURL=VoiceTranscriptBubble.js.map
